import React from 'react';
import { useTranslation } from 'react-i18next';

export type InputMethod = 'url' | 'text';

interface InputMethodSelectorProps {
  inputMethod: InputMethod;
  onInputMethodChange: (method: InputMethod) => void;
  translationNamespace?: string;
}

const InputMethodSelector: React.FC<InputMethodSelectorProps> = ({
  inputMethod,
  onInputMethodChange,
  translationNamespace = 'social',
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <label className="block text-gray-700 mb-3">
        {t(`${translationNamespace}.input_method`)}
      </label>
      <div className="flex gap-6">
        <label className="flex items-center">
          <input
            type="radio"
            name="inputMethod"
            value="url"
            checked={inputMethod === 'url'}
            onChange={(e) => onInputMethodChange(e.target.value as InputMethod)}
            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
          />
          <span className="ml-2 text-sm text-gray-700">{t(`${translationNamespace}.use_url`)}</span>
        </label>
        <label className="flex items-center">
          <input
            type="radio"
            name="inputMethod"
            value="text"
            checked={inputMethod === 'text'}
            onChange={(e) => onInputMethodChange(e.target.value as InputMethod)}
            className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
          />
          <span className="ml-2 text-sm text-gray-700">
            {t(`${translationNamespace}.use_text`)}
          </span>
        </label>
      </div>
    </div>
  );
};

export default InputMethodSelector;
